var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('app-admin-header'),_c('div',{staticClass:"clearfix"}),_c('div',{attrs:{"id":"dashboard"}},[_c('app-admin-sidebar'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }